import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { select, Store } from '@ngrx/store';
import { Observable, of, ReplaySubject, throwError } from 'rxjs';
import {
    catchError,
    filter,
    map,
    take,
    takeWhile,
    withLatestFrom
} from 'rxjs/operators';
import { AppComponent } from './app.component';
import * as fromAuth from './auth';
import { PinDialogComponent } from './auth';
import { CompanyAccessDialogComponent } from './auth/company-access-dialog/company-access-dialog.component';
import * as fromDataServices from './data-services';
import { DialogService, Process } from './shared';
import { getErrorAction } from './shared/errors-sidenav';
import { LoggingService } from './shared/services/logging';
import * as fromUser from './user-info';
import { UserRoleEnum } from './user-info';
import { IUserRole } from './user-role/IUserRole';
import { environment } from '../environments/environment';
import * as fromRoot from './store';
@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styleUrls: ['./app.topbar.component.scss'],
    standalone: false
})
export class AppTopBarComponent implements OnInit, OnDestroy {
    private componentActive = true;
    // public mainProcess$: Observable<Process[]>;
    auth$: Observable<fromAuth.State>;
    private switchCompanySubject = new ReplaySubject<string>(1);
    @Input() userInfo: fromUser.IUserInfo;
    @Input() user: fromUser.IUserAccess;
    @Input() roles: IUserRole[];
    private companyAccessDataService: EntityCollectionService<fromDataServices.CompanyAccess.CompanyAccessModel>;
    @Input() processes: Process[];
    @Input() processTitles: string[];

    showAbout = false;
    public environment = environment;
    public version$: Observable<string>;
    eFAACTApiVersion: string;
    eFAACTVersion = `${environment.version}-${environment.environment}`;
    softwareLicenseAgreementLink = "https://www.efaactcentral.com/licensing/eFAACTHostedLicenseAgreement.htm";

    selectedProcess: Process;
    constructor(
        public app: AppComponent,
        private store: Store<fromUser.State>,
        public entityServices: EntityServices,
        private log: LoggingService,
        private dialogService: DialogService
    ) {
        this.companyAccessDataService =
            entityServices.getEntityCollectionService<fromDataServices.CompanyAccess.CompanyAccessModel>(
                fromDataServices.CompanyAccess.entityName
            );
        this.companyAccessDataService.clearCache();
    }

    ngOnDestroy() {
        this.componentActive = false;
    }
    ngOnInit() {
        // this.mainProcess$ = this.store.pipe(
        //     select(fromUser.getUserProcessesMain),
        //     map(processes => processes.filter(p => p.displayinmenu))
        // );

        this.auth$ = this.store.pipe(select(fromAuth.getAuth));
        this.setupSubscriptions();
    }
    setupSubscriptions() {

        setTimeout(() => {
            this.version$ = this.store.pipe(
                select(fromRoot.Version.selectVersion)
            );
            this.version$.pipe(take(2)).subscribe(v => {
                this.eFAACTApiVersion = v;
            });
        }, 1000);
        this.companyAccessDataService.entities$
            .pipe(
                takeWhile(() => this.componentActive),
                filter(x => !!x && x.length > 0),
                withLatestFrom(this.auth$)
            )
            .subscribe(([companyAccess, auth]) => {
                this.log.verbose({
                    type: 'AppTopBarComponent:companyAccessDataService:entities$',
                    companyAccess
                });
                this.dialogService
                    .open(CompanyAccessDialogComponent, {
                        header: 'Select Company Access',
                        closable: false,
                        closeOnEscape: false,
                        showHeader: false,
                        modal: true,
                        data: {
                            userInfo: this.userInfo,
                            companies: companyAccess
                        }
                    })
                    .onClose.pipe(take(1))
                    .subscribe(data => {
                        this.log.verbose({
                            type: 'AppTopBarComponent:CompanyAccessDialogComponent:afterClosed',
                            data
                        });
                        const company = companyAccess.find(
                            x => x.id === data.company
                        );
                        this.log.verbose({
                            type: 'AppTopBarComponent:CompanyAccessDialogComponent:afterClosed',
                            company
                        });
                        this.companyAccessDataService.clearCache();
                        this.companyAccessDataService
                            .getWithQuery({
                                CustomerID: company.CustomerID.toString(),
                                contactemail: company.contactemail
                            })
                            .pipe(
                                take(1),
                                catchError(err => {
                                    this.log.error(err);
                                    throwError(err);
                                    return of(getErrorAction(err));
                                })
                            )
                            .subscribe(q => {
                                this.log.verbose({
                                    type: 'AppTopBarComponent:companyAccessDataService:getWithQuery',
                                    q
                                });
                                this.store.dispatch(
                                    new fromAuth.RememberMe({
                                        rememberMe: auth.rememberMe,
                                        username: null,
                                        pin: company.CustomerID.toString()
                                    })
                                );
                                this.store.dispatch(new fromAuth.Logout());
                            });
                    });
            });
        this.switchCompanySubject
            .pipe(
                takeWhile(() => this.componentActive),
                withLatestFrom(this.auth$)
            )
            .subscribe(([, auth]) => {
                this.log.verbose({
                    type: 'AppTopBarComponent:switchCompanySubject'
                });
                this.dialogService
                    .open(PinDialogComponent, {
                        header: 'Enter main customer ID/PIN',
                        closable: false,
                        closeOnEscape: false,
                        showHeader: false,
                        modal: true,
                        data: {
                            userInfo: this.userInfo
                            // pin: auth.pin
                        }
                    })
                    .onClose.pipe(take(1))
                    .subscribe(data => {
                        this.log.verbose({
                            type: 'AppTopBarComponent:switchCompanySubject:afterClosed',
                            data
                        });
                        if (!!data && !!data.pin) {
                            this.companyAccessDataService.getWithQuery({
                                CustomerID: data.pin
                            });
                        }
                    });
            });
    }
    openAbout() {
        this.showAbout = true;
    }
    openHelpDesk() {
        if (this.user) {
            if (this.user.UserProcessesMain && this.user.UserProcessesMain.length > 0) {
                const helpdeskProcess = this.user.UserProcessesMain.find(x => x.ProcessID == 134);
                const helpdeskLink = helpdeskProcess.UrlDemo;
                window.open(helpdeskLink, '_blank');
            }
        }
    }
    openUserManual() {
        window.open(
            'https://www.efaactcentral.com/eFAACTUserManual/index.htm?',
            '_blank'
        );
    }
    openCompanyCalendar() {}
    roleChosen(roleID: number) {
        this.store.dispatch(
            new fromUser.SetUserInfo({
                ...this.userInfo,
                DefaultRoleGroupID: roleID
            })
        );
    }
    switchCompany() {
        this.log.verbose({ type: 'AppTopBarComponent:switchCompany' });
        this.switchCompanySubject.next();
    }
    isAdmin = (roles: IUserRole[]): boolean =>
        roles &&
        !!roles.find(x => x.RoleGroupID === UserRoleEnum.Administrator);

    filterProcessFromSearch($event) {
        this.processTitles = [];
        // const filteredProcesses = this.processes.filter(x =>
        //     x.ProcessTitle.toLowerCase().includes($event.query.toLowerCase()) ||
        //     x.ProcessDesc != null
        //         ? x.ProcessDesc.toLowerCase().includes(
        //               $event.query.toLowerCase()
        //           )
        //         : x.ProcessTitle.toLowerCase().includes(
        //               $event.query.toLowerCase()
        //           )
        // );

        const filteredProcesses = this.processes.filter(process => {
            if (process.ProcessDesc != null) {
                return (
                    process.ProcessDesc.toLowerCase().includes(
                        $event.query.toLowerCase()
                    ) ||
                    process.ProcessTitle.toLowerCase().includes(
                        $event.query.toLowerCase()
                    )
                );
            } else {
                return process.ProcessTitle.toLowerCase().includes(
                    $event.query.toLowerCase()
                );
            }
        });

        filteredProcesses.forEach(x => {
            this.processTitles.push(x.ProcessTitle);
        });
        this.log.verbose('text from search: ' + $event.query);
    }
    gotoProcessFromSearch(value) {
        this.log.verbose('selected process from search: ' + value);
        const process = this.processes.find(x => x.ProcessTitle == value);
        this.app.goto(process);
    }
}
